import { serializeRichtextToText } from '@nucleus/deprecated-rich-text';
import { PostWeb } from '@nucleus/types/web/posts/post';
import { PostIndexDocumentWeb } from '@nucleus/web-hosting';
import React from 'react';
import { estimateReadingTime } from '../lib/estimate-reading-time';

interface Props {
  post?: PostWeb | PostIndexDocumentWeb;
}

/** PostWeb has body as RichTextNodeArray */
const isPostWeb = (post: PostWeb | PostIndexDocumentWeb): post is PostWeb => {
  return 'body' in post && typeof post.body !== 'string' && !('bodyText' in post);
};

/** PostIndexDocumentWeb has bodyText as string */
const isPostIndexDocumentWeb = (post: PostWeb | PostIndexDocumentWeb): post is PostIndexDocumentWeb => {
  return 'bodyText' in post && typeof post.bodyText === 'string';
};

export const PostReadingTime = (props: Props): JSX.Element | null => {
  if (props.post === undefined) {
    return null;
  }

  let text = '';

  if (isPostWeb(props.post)) {
    // PostWeb has body as RichTextNodeArray, need to extract text
    if (props.post.body !== undefined) {
      text = serializeRichtextToText(props.post.body);
    }
  } else if (isPostIndexDocumentWeb(props.post)) {
    // PostIndexDocumentWeb has bodyText as string
    text = props.post.bodyText ?? '';
  }

  if (text === '') {
    return null;
  }

  return <>{`${estimateReadingTime(text)} Minute Read`}</>;
};
